module.exports = __webpack_public_path__ + "static/orion360_sdk_map-213bf00a402dba59d162037f100e30fd.jpg";